import React, { useState } from 'react';

import { getToken } from "firebase/messaging";
import { messaging } from "./../../AssetsM/firebase";
import { Button } from 'semantic-ui-react';
import axios from 'axios';

function NotificationsPage() {
    let compteData = JSON.parse(localStorage.getItem(`PID`));
    const compteAuth = compteData; 
    const [tokenIdValue, setTokenIdValue] = useState(localStorage.getItem('notifToken'))

    async function requestPermission() {
        //requesting permission using Notification API
        const permission = await Notification.requestPermission();
    
        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey: 'BLi4rh1fVu7f9p_RBBscq7eQs3tY8yETbeW7p0tj2oH9oM0rnAxwSDs1F4Xy6Q0bITAo9F_fTxwLz3TA3-4Gw5U',
          });
    
          //We can send token to server
          console.log("Token generated : ", token);
          localStorage.setItem('notifToken', token)
          setTokenIdValue(token)
        } else if (permission === "denied") {
          //notifications are blocked
          console.log("You denied for the notification");
        }
    }

    const SaveNewTokenToServer = () => {
          axios.post(`https://api.system.ansl.tn/API/salle-app/update-notification-token`, {
            token : tokenIdValue ,
          })
          .then(function (response) {
              console.log(response)
              alert('تم تغيير المعرف  ')
          })
    }

    const PageIndisponoble = () => {
      return(<>
          <h2>Cette Page n'est pas disponible pour toi </h2>

      </>)
    }
    return ( <> Notif Page 
    
    <br />
    {compteAuth.NFT == 'true' ? 
        <>
        <div className='d-block text-break'> {tokenIdValue}</div>
        <br />
        <Button className='mb-2' onClick={() => requestPermission()}>Modifier Token </Button> 
        <Button className='mb-2' onClick={() => navigator.clipboard.writeText(tokenIdValue)}>Copier Token  </Button>
        <Button className='mb-2' onClick={() => SaveNewTokenToServer()}> Metre a jour Token   </Button>
        </> 
     : <PageIndisponoble />}

   
    
    </> );
}

export default NotificationsPage;